// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__OQoe9"};